import { MutationTree, GetterTree, Module } from 'vuex'
import { RootState } from '@/@next/store'

// Types
export const GET_ACCESSIBILITY = 'style/GET_ACCESSIBILITY'
export const GET_LOCAL_STYLE = 'style/GET_LOCAL_STYLES'
export const GET_DEFAULT_STYLE = 'style/GET_DEFAULT_STYLE'
export const GET_HIGH_CONTRAST_STYLE = 'style/GET_HIGH_CONTRAST_STYLE'
export const GET_ACCESSIBILTY_KEYS = 'style/GET_ACCESSIBILTY_KEYS'
export const GET_STYLE_KEYS = 'style/GET_STYLE_KEYS'

export const SET_ACCESSIBILITY = 'style/SET_ACCESSIBILITY'
export const SET_LOCAL_STYLE = 'style/SET_LOCAL_STYLE'
export const SET_DEFAULT_STYLE = 'style/SET_DEFAULT_STYLE'

const docStyle = getComputedStyle(document.documentElement)
const getStyleValue = (prop: string): string => docStyle.getPropertyValue(prop)
const styleKeys = [
  'primaryColor', 'onPrimaryColor',
  'secondaryColor', 'onSecondaryColor',
  'backgroundColor', 'onBackgroundColor',
  'textOnForegroundColor', 'foregroundColor',
  'menuBackgroundColor', 'menuColor',
  'cardTitleBackgroundColor', 'cardTitleBackgroundRight', 'cardTitleBackgroundLeft', 'cardTitleBackgroundBottom', 'cardTitleBackgroundMarginTop', 'cardTitleBackgroundPadding', 'cardTitleBackgroundMaxWidth', 'cardTitleTextColor', 'cardSummaryTextColor', 'cardTitleBackgroundBottomTablet',
  'sansSerifFontStack', 'serifFontStack',
  'poiCardTitleBackgroundColor', 'poiCardTitleBackgroundRight', 'poiCardTitleBackgroundBottom', 'poiCardTitleBackgroundLeft', 'poiCardTitleBackgroundPadding', 'poiCardTitleBackgroundMaxWidth', 'poiCardTitleTextColor', 'poiCardTitleTextAlign', 'poiCardTitleTextTransform',
  'textOnTopbarColor',
  'poiTitleColor'
]

export class StyleState {
  localStyle: any = null
  accessibility: any = {
    textSize: 100,
    greyScale: 0,
    wordSpacing: 0,
    dyslexicFont: false,
    highContrast: false,
    textToSpeech: false,
  }
  highContrastStyle: any = {
    primaryColor: getStyleValue('--backgroundContrastColor'),
    onPrimaryColor: getStyleValue('--onBackgroundContrastColor'),
    backgroundColor: getStyleValue('--onBackgroundContrastColor'),
    onBackgroundColor: getStyleValue('--backgroundContrastColor'),
    textOnForegroundColor: getStyleValue('--backgroundContrastColor'),
    foregroundColor: getStyleValue('--onBackgroundContrastColor'),
    menuBackgroundColor: getStyleValue('--backgroundContrastColor'),
    menuColor: getStyleValue('--onBackgroundContrastColor'),
    cardTitleBackgroundColor: getStyleValue('--backgroundContrastColor'),
    cardTitleTextColor: getStyleValue('--onBackgroundContrastColor'),
    cardSummaryTextColor: getStyleValue('--onBackgroundContrastColor')
  }
  styleKeys = styleKeys
  defaultStyle = Object.fromEntries(styleKeys.map((key: string) => [key, getStyleValue(`--${key}`)]));
}

const state: StyleState = new StyleState()

const getters: GetterTree<StyleState, RootState> = {
  [GET_ACCESSIBILITY]: (state) => state.accessibility,
  [GET_LOCAL_STYLE]: (state) => state.localStyle,
  [GET_DEFAULT_STYLE]: (state) => state.defaultStyle,
  [GET_HIGH_CONTRAST_STYLE]: (state) => state.highContrastStyle,
  [GET_ACCESSIBILTY_KEYS]: (state) => Object.keys(state.accessibility),
  [GET_STYLE_KEYS]: (state) => state.styleKeys
}

const mutations: MutationTree<StyleState> = {
  [SET_ACCESSIBILITY]: (state, props: any) => state.accessibility = {...state.accessibility, ...props},
  [SET_LOCAL_STYLE]: (state, style: any) => state.localStyle = style,
  [SET_DEFAULT_STYLE]: (state, style: any) => state.defaultStyle = { ...state.defaultStyle, ...style}
}

export const style: Module<StyleState, RootState> = {
  state,
  getters,
  mutations
}
